// extracted by mini-css-extract-plugin
export default {"flavor_option":"uI","out_of_stock_text":"vI","out_of_stock":"wI","flavor_option_image":"xI","flavor_option_info":"yI","flavor_option_title":"zI","flavor_option_limited":"AI","flavor_option_amount_wrapper":"BI","flavor_option_amount_button":"CI","zero_amount":"EI","no_flavors":"FI","no_flavors_active":"GI","flavor_option_select_wrapper":"HI","flavor_option_select_wrapper__selected":"II"};
    if(module.hot) {
      // 1713912566149
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  